import { StateChipPill, type StateChipSize } from '@/components/state-chips';
import type { StateChip } from '@/domain/state-chips';

/**
 * A lifecycle state (docs/DESIGN_SYSTEM.md "Values and entries"): the state
 * chip exactly as `src/components/state-chips.tsx` draws it, outlined and
 * dotless (Active is the green outlined chip). It delegates and draws
 * nothing of its own; the chip's text is its words (`lifecycleWords`).
 * Server-safe.
 */
export function LifecycleValue({ chip, size }: { chip: StateChip; size?: StateChipSize }) {
  return <StateChipPill chip={chip} size={size} data-value="lifecycle" />;
}
